// extracted by mini-css-extract-plugin
export default {"loadingIcon":"src-components-LoadingIcon-index-module_loadingIcon--FhmgL"};